import { Injectable } from '@angular/core';
import { BaseResolver } from '@app/app.resolver';
import { ModelFactory } from '@app/models/core/model-factory';
import { Employee } from '@app/models/employee/employee.model';
import { ProjectAssignment } from '@app/models/time-tracking/project-assignment.model';
import { TimesheetEntry } from '@app/models/time-tracking/timesheet-entry.model';
import { Project } from '@models/time-tracking/project.model';

@Injectable()
export class TimeTrackingResolver extends BaseResolver {
    protected modelFactory: ModelFactory = new ModelFactory([
        {
            className: 'project',
            production: {
                find: (id: number) => {
                    return Project.with(['assignments.employee', 'ownerships.owner']).find(id);
                },
            },
        },
        {
            className: 'timesheetEntry',
            production: {
                find: (id: number) => {
                    return TimesheetEntry.with(['project', 'employee', 'timeClockEntry']).find(id);
                },
            },
        },
        {
            className: 'projectAssignment',
            production: {
                find: (id: number) => {
                    return ProjectAssignment.with(['project', 'project.ownerships.owner', 'employee']).find(id);
                },
            },
        },
        {
            className: 'employee',
            production: {
                find: (id: number) => {
                    return Employee.param('company', this.companyId)
                        .with(['timeTrackingProjectAssignmentsUserCanEnterHoursFor.project'])
                        .find(id);
                },
            },
        },
    ]);
}
